import getInstance from "../config/api";

export default class BlockList {
  // Clients
  static async fetchClientsBlockList(params) {
    const instance = getInstance();
    const { data } = await instance.get("/block-list", { params });
    return data;
  }

  static async fetchClientBlockListById(id) {
    const instance = getInstance();
    const { data } = await instance.get(`/block-list/${id}`);
    return data;
  }

  static async createClientBlockList(body) {
    const instance = getInstance();
    const { data } = await instance.post("/block-list", body);
    return data;
  }

  static async updateClientBlockList(id, body) {
    const instance = getInstance();
    const { data } = await instance.put(`/block-list/${id}`, body);
    return data;
  }

  static async deleteClientBlockList(id) {
    const instance = getInstance();
    const { data } = await instance.delete(`/block-list/${id}`);
    return data;
  }

  static async importCsvClientBlockList(body) {
    const instance = getInstance();
    const { data } = await instance.post(`/block-list/csv`, body);
    return data;
  }

  static async downloadClientBlockListCSV(params) {
    const instance = getInstance();
    const data = await instance.get("/block-list/export", { params });
    return data;
  }

  // City

  static async fetchCitiesBlockList(params) {
    const instance = getInstance();
    const { data } = await instance.get("/block-list-cities", { params });
    return data;
  }

  static async fetchCityBlockListById(id) {
    const instance = getInstance();
    const { data } = await instance.get(`/block-list-cities/${id}`);
    return data;
  }

  static async fetchLocalesBlockList() {
    const instance = getInstance();
    const { data } = await instance.get(`/block-list-cities/locales`);
    return data;
  }

  static async createCityBlockList(body) {
    const instance = getInstance();
    const { data } = await instance.post("/block-list-cities", body);
    return data;
  }

  static async updateCityBlockList(id, body) {
    const instance = getInstance();
    const { data } = await instance.put(`/block-list-cities/${id}`, body);
    return data;
  }

  static async deleteCityBlockList(id) {
    const instance = getInstance();
    const { data } = await instance.delete(`/block-list-cities/${id}`);
    return data;
  }

  static async importCsvCityBlockList(body) {
    const instance = getInstance();
    const { data } = await instance.post(`/block-list-cities/csv`, body);
    return data;
  }

  static async downloadCityBlockListCSV(params) {
    const instance = getInstance();
    const data = await instance.get("/block-list-cities/export", { params });
    return data;
  }
}
